import { MatterDocsWithCasesFilters } from '../../../../../../../../backend/src/matter/doc/dto/doc-with-cases.response.dto';
import { DateRangeFilter } from '@/new/components/date-range-filter';
import { FilterPopoverContent } from '@/new/components/filter-popover-content';
import {
  FilterField,
  ServerSideFilterPopover as GenericServerSideFilterPopover,
} from '@/new/components/server-side-filter-popover';
import { Label } from '@/new/components/shadcn/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/new/components/shadcn/select';

interface DocsFilterPopoverProps {
  filters: MatterDocsWithCasesFilters;
  onFiltersChange: (filters: MatterDocsWithCasesFilters) => void;
  clearAllFilters: () => void;
}

const filterFields: FilterField[] = [
  {
    type: 'select',
    key: 'processed',
    label: 'Processing Status',
    placeholder: 'Select processing status...',
    options: [
      { value: 'true', label: 'Processed' },
      { value: 'false', label: 'Not Processed' },
    ],
  },
  {
    type: 'dateRange',
    startKey: 'startDate',
    endKey: 'endDate',
    label: 'Upload Date Range',
  },
];

export function ServerSideFilterPopover({ filters, onFiltersChange, clearAllFilters }: DocsFilterPopoverProps) {
  return (
    <GenericServerSideFilterPopover
      filters={filters}
      onFiltersChange={onFiltersChange}
      clearAllFilters={clearAllFilters}
      fields={filterFields}
    />
  );
}
